import { Grid } from '@material-ui/core'
import React from 'react'

function DisplayMessage({ html }) {
  return (
    <div 
      className="welcome-message"
      style={{ marginBottom: '30px' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

export default DisplayMessage
